import styled from "@emotion/styled";
import * as React from "react";

import { Icon, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ratingToColorMap, ratingToIconMap, ratingToTextMap } from "constants/rating";
import { IRatingEvent } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  rating: IRatingEvent;
}

const Comment = styled.p`
  margin-top: 1em;
  font-style: italic;
  white-space: pre-line;
`;

export const TicketEventRating: React.FC<IProps> = ({ rating }) => (
  <Flex column alignItems="center" gap={withVar(SpacingToken.Spacing4)}>
    <Icon source={ratingToIconMap[rating.rate]} customColor={ratingToColorMap[rating.rate]} size="xxlarge" />
    <p>
      This ticket was rated as <strong>{ratingToTextMap[rating.rate]}</strong>
    </p>
    {rating.comment && <Comment>{rating.comment}</Comment>}
  </Flex>
);
